module.exports = __webpack_public_path__ + "static/img/lisa.9a00f835.png";